import React from 'react';

const selStyle = { width: '100%', padding: '8px 10px', border: '1px solid #D1D5DB', borderRadius: '8px' };

export const LoanInterestFields = ({ data, onChange, currencySymbol, prefix }) => {
  const set = (k, v) => onChange({ ...data, [k]: v });
  const isFixed = data.interest_type === 'fixed_amount';
  const period = data.rate_period || 'monthly';
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', gridColumn: '1 / -1' }}>
      <div className="form-group">
        <label>Interest Type *</label>
        <select style={selStyle} value={data.interest_type} onChange={e => set('interest_type', e.target.value)} data-testid={`${prefix}-interest-type`}>
          <option value="simple">Simple</option>
          <option value="compound">Compound</option>
          <option value="fixed_amount">Fixed Amount ({currencySymbol}/month)</option>
        </select>
      </div>
      {!isFixed && (
        <div className="form-group">
          <label>Rate Period *</label>
          <select style={selStyle} value={period} onChange={e => set('rate_period', e.target.value)} data-testid={`${prefix}-rate-period`}>
            <option value="monthly">Per Month</option>
            <option value="annual">Per Year</option>
          </select>
        </div>
      )}
      <div className="form-group">
        <label>{isFixed ? `Interest Amount (${currencySymbol}/month) *` : `Interest Rate (% per ${period === 'monthly' ? 'month' : 'year'}) *`}</label>
        <input style={selStyle} type="number" step="0.1" min="0" value={data.interest_rate} onChange={e => set('interest_rate', e.target.value)} required data-testid={`${prefix}-rate-input`} />
      </div>
      <div className="form-group">
        <label>Repayment Mode *</label>
        <select style={selStyle} value={data.repayment_mode || 'interest_only'} onChange={e => set('repayment_mode', e.target.value)} data-testid={`${prefix}-repayment-mode`}>
          <option value="interest_only">Interest Monthly, Principal at End</option>
          <option value="principal_and_interest">Principal + Interest Monthly</option>
        </select>
      </div>
    </div>
  );
};

export const LoanSchedulePreview = ({ rows, fmt }) => {
  if (!rows.length) return null;
  const totalInterest = rows.reduce((s, r) => s + r.interest, 0);
  const first = rows[0];
  const last = rows[rows.length - 1];
  return (
    <div data-testid="loan-schedule-preview" style={{ gridColumn: '1 / -1', background: '#F0FDF4', border: '1px solid #BBF7D0', borderRadius: '8px', padding: '10px 12px', fontSize: '13px' }}>
      <div data-testid="preview-first-payment">Months 1–{rows.length > 1 ? rows.length - 1 : 1}: <strong>{fmt(first.total)}</strong>/month</div>
      <div data-testid="preview-final-payment">Month {last.month} (final): <strong>{fmt(last.total)}</strong></div>
      <div data-testid="preview-total-interest">Total interest: <strong>{fmt(totalInterest)}</strong> · Total repayment: <strong>{fmt(totalInterest + rows.reduce((s, r) => s + r.principal, 0))}</strong></div>
    </div>
  );
};
